<template>
    <div class="bus-status">
        <div class="bus-status__button">
            <el-button @click="isDialogOpen = true">{{ $t('schedule.bus_status') }}</el-button>
            <i class="el-icon-warning error-icon" v-show="!status"></i>
        </div>
        <el-dialog
            :title="$t('schedule.bus_status')"
            :visible.sync="isDialogOpen"
            width="90%">
            <el-row :gutter="20">
                <el-col :span="6" v-for="(bus,ind) in busStatus" :key="ind">
                    <table>
                        <tr>
                            <th width="30%">{{ $t('common.bus') }}</th>
                            <th width="70%">{{ bus.info.name }}</th>
                        </tr>
                        <tr v-for="(count, time) in bus.count" :key="time" :class="{ 'count-error': count > bus.info.available_seats }">
                            <td class="font-weight-bold">{{ time }}</td>
                            <td>{{ count }} / {{ bus.info.available_seats }}</td>
                        </tr>
<!--                      <tr>-->
<!--                        <td></td>-->
<!--                        <td>-->
<!--                           {{totalStudent(bus.count) }} / {{ bus.info.available_seats }}-->
<!--                        </td>-->
<!--                      </tr>-->
                    </table>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isDialogOpen = false">{{ $t('common.cancel') }}</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: 'busStatus',
        props: ['dataList'],
        methods: {
          // totalStudent(bus){
          //   if(bus){
          //     let total = 0
          //     for( let key in bus){
          //       total += bus[key]
          //     }
          //     return total
          //   }else{
          //     return  ''
          //   }
          // }
        },
        data () {
            return {
                isDialogOpen: false,
                status: true
            }
        },
        computed: {
            ...mapState('schedule', ['masterData']),
            busStatus () {
                let busStatus = {}
                let busList = {}

                if (this.masterData.bus_list) {
                    this.masterData.bus_list.forEach((item) => {
                        busList[item.id] = item
                    })

                    Object.values(this.dataList).forEach((studentData) => {
                        if (!studentData.time.HH || !studentData.time.mm || !studentData.bus_id) {
                            return
                        }

                        let time = `${studentData.time.HH}:${studentData.time.mm}`

                        if (typeof busStatus[studentData.bus_id] === 'undefined') {
                            busStatus[studentData.bus_id] = {
                                info: busList[studentData.bus_id],
                                count: {}
                            }
                        }

                        if (typeof busStatus[studentData.bus_id].count[time] === 'undefined') {
                            busStatus[studentData.bus_id].count[time] = 0
                        }

                        busStatus[studentData.bus_id].count[time]++
                    })
                }

                return busStatus
            }
        },
        watch: {
            busStatus: {
                deep: true,
                handler: function () {
                    let status = true

                    Object.values(this.busStatus).forEach((bus) => {
                        Object.values(bus.count).forEach((count) => {
                            if (count > bus.info.available_seats) {
                                status = false
                            }
                        })
                    })

                    this.status = status
                    this.$emit('updateBusStatus', status)
                }
            }
        },
    }
</script>

<style lang="scss">
    .bus-status {
        .count-error {
            background: #ff0000;
        }

        &__button {
            position: relative;

            .error-icon {
                color: #ff0000;
                font-size: 20px;
                position: absolute;
                top: -10px;
                right: -10px;
            }
        }

        .el-dialog__body {
            .el-col {
                margin-bottom: 20px;

                table {
                    width: 100%;
                }
            }
        }
    }
</style>
